import { Link } from 'react-router-dom';

const articleLinks = [
  { title: 'Complete Guide 2026', path: '/sugargoo-spreadsheet-guide' },
  { title: 'Sugargoo Review 2026', path: '/sugargoo-review-2026' },
  { title: 'Shipping Cost Guide', path: '/sugargoo-shipping-guide' },
  { title: 'Safety & Legitimacy', path: '/sugargoo-safety-legit' },
  { title: 'Coupon & Discount Guide', path: '/sugargoo-coupon-guide' },
  { title: 'Beginner Tutorial', path: '/sugargoo-beginner-tutorial' },
  { title: 'Haul Building Guide', path: '/sugargoo-haul-guide' },
  { title: 'QC Photo Guide', path: '/sugargoo-qc-guide' },
  { title: 'vs Alternatives', path: '/sugargoo-vs-alternatives' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-lg font-heading font-semibold text-foreground-900">
              Sugargoo <span className="text-primary-600">Spreadsheet</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              Your ultimate resource hub for Sugargoo Spreadsheet guides, product finds, shipping tips, and shopping strategies. Updated daily for the global shopping community.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">Home</Link></li>
              <li><a href="#categories" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Popular Categories</a></li>
              <li><a href="#what-is" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">What Is Sugargoo Spreadsheet</a></li>
              <li><a href="#review" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Sugargoo Review</a></li>
              <li><a href="#shipping" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Shipping Cost Guide</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">SEO Guides</h4>
            <ul className="space-y-2.5">
              {articleLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">Shop Now</h4>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Visit our main website for the latest Sugargoo Spreadsheet product categories and daily updated finds.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} sugargoospread.help — Your Sugargoo Spreadsheet Resource Hub. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            This is an independent informational resource. Not affiliated with Sugargoo.
          </p>
        </div>
      </div>
    </footer>
  );
}